import styled, { css } from "styled-components";
import { rgba } from "polished";

export const SidebarWrapper = styled.div<{ hideInfo?: boolean; noBg?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 32px;
  width: 100%;
  max-height: 100dvh;
  position: relative;
  padding-block: 112px 144px;
  overflow-y: hidden;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.laptop}px`}) {
    padding-block: 80px 112px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    width: 100%;
    max-width: none;
    height: auto;
    position: static;
    padding-block: 24px 32px;
  }

  ${({ hideInfo }) =>
    hideInfo
      ? css`
          padding-bottom: 0;
        `
      : null}

  ${({ noBg }) =>
    noBg
      ? css`
          @media (max-width: ${({ theme }) =>
              `${theme.breakpoints.tablet}px`}) {
            background-color: transparent;
          }
        `
      : null}
`;

export const SocialLinks = styled.div`
  width: 100%;
  margin-top: 24px;
  position: relative;
`;

export const SocialLinksContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  &.full-length {
    justify-content: space-between;
    @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
      justify-content: center;
    }
  }

  & > * {
    flex: 0 0 auto;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    gap: 12px;
  }
`;

export const SidebarHighlight = styled.div`
  margin-top: 32px;
`;

export const Wrapper = styled.div`
  display: grid;

  .cart-button {
    margin-inline: auto 0;
    margin-block: 0 44px;
  }
`;

export const StreamsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;

  .title-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;
    font-family: ${({ theme }) => theme.fonts.UrbaneDemiBold};

    .streams-status {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 5px;
      color: ${({ theme }) => theme.colors.primary};
      .streams-status-number {
        font-family: ${({ theme }) => theme.fonts.UrbaneDemiBold};
        color: ${({ theme }) => rgba(theme.colors.primary, 0.5)};
        margin-block: 0;
        &[data-status="up"],
        &.up {
          color: ${({ theme }) => theme.colors.success};
        }
        &[data-status="down"],
        &.down {
          color: ${({ theme }) => theme.colors.accent};
        }
      }
    }
  }

  .streams-number {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    font-family: ${({ theme }) => theme.fonts.UrbaneDemiBold};
    line-height: normal;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.primary};
    margin: 0;
  }

  .streams-text {
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    font-family: ${({ theme }) => theme.fonts.UrbaneDemiBold};
    line-height: normal;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.primary};
    opacity: 0.5;
    margin-top: 2px;
    margin-bottom: 0;
  }
`;
